<div class="loading-blocker" role="status" [class.d-none]="!isBlocked()">
  <div class="spinner-border text-primary" aria-hidden="true"></div>
  <span class="visually-hidden">Loading...</span>
</div>

<router-outlet>

</router-outlet>

<div class="toast-container position-fixed top-0 end-0 p-3">
  @for (toast of toastList(); track toast) {
  <ngb-toast
    [autohide]="toast.delay > 0"
    [class]="toast.className"
    [delay]="toast.delay"
    (hidden)="closeToast(toast)">
    @switch(toast.className) {
    @case ('error') {
    <div class="d-flex align-items-center">
      <span class="icon"><fa-icon [icon]="fasExclamation"></fa-icon></span>
      <div class="d-flex flex-grow-1 align-items-center">
        <span class="fw-medium w-100">{{toast.msg}}</span>
        <button type="button" class="btn-close btn-close-sm ms-2" (click)="closeToast(toast)" aria-label="Close"></button>
      </div>
    </div>
    }
    @case ('success') {
    <div class="d-flex align-items-center">
      <span class="icon"><fa-icon [icon]="fasCheck"></fa-icon></span>
      <div class="d-flex flex-grow-1 align-items-center">
        <span class="fw-medium w-100">{{toast.msg}}</span>
        <button type="button" class="btn-close btn-close-sm ms-2" (click)="closeToast(toast)" aria-label="Close"></button>
      </div>
    </div>
    }
    @default {
    <div class="d-flex flex-grow-1 align-items-center">
      <span class="fw-medium w-100">{{toast.msg}}</span>
      <button type="button" class="btn-close btn-close-sm ms-2" (click)="closeToast(toast)" aria-label="Close"></button>
    </div>
    }
    }

  </ngb-toast>
  }
</div>